<template>
	<div class="flex xs-12 m0 xs-wrap">
		<div class="xs-12 flex xs-wrap">
			<div
				class="tree-item flex xs-12 xs-middle xs-center"
				@click="setSelectedNode(node)"
				:class="{ mb2: !expanded || node.hasChildren() || !node.hasChildren() }"
			>
				<div class="flex xs-6">
					<div class="flex xs-12">
						<div class="flex xs-1 lg-2 ta2 xs-center" @click="expand">
							<div class="flex xs">
								<crm-icon
									v-if="node.hasChildren()"
									name="chevron-right"
									class="arrow expander xs-center xs-middle flex"
									:class="{ 'arrow-rotated': expanded }"
								/>

								<crm-icon v-else name="circle" />
							</div>
						</div>
						<div class="xs flex disable_selection">{{ node.name }}</div>
					</div>
				</div>

				<div class="flex xs-6 xs-right">
					<j-button
						:isDisabled="node.tooDeep()"
						class="mr1"
						type="secondary"
						size="xsmall"
						@click="$emit('addChildBenefit', node)"
					>
						<crm-icon name="add" size="small" color="c5" />
						{{ $t("add_child") }}
					</j-button>

					<j-button
						class="mr1"
						type="secondary"
						size="xsmall"
						@click="$emit('showUpdateNameModal', node)"
					>
						<crm-icon name="edit" size="small" color="c5" />
						{{ $t("edit") }}
					</j-button>

					<j-button
						type="error"
						size="xsmall"
						@click="$emit('removeBenefit', node)"
					>
						{{ $t("remove") }}
					</j-button>
				</div>
			</div>

			<template v-if="expanded && node.children" class="fadein">
				<benefit-node
					class="pl4"
					v-for="(node, i) in node.children"
					:node="node"
					:key="`${node.typeId}-${i}`"
					@selected="$event => $emit('selected', $event)"
					@addChildBenefit="$event => $emit('addChildBenefit', $event)"
					@removeBenefit="$event => $emit('removeBenefit', $event)"
					@showUpdateNameModal="$event => $emit('showUpdateNameModal', $event)"
				/>
			</template>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton/"

export default {
	name: "benefit-node",
	components: {
		CrmIcon,
		JButton
	},
	props: {
		node: {
			type: Object
		}
	},
	data: () => ({
		expanded: false,
		hover: false
	}),
	methods: {
		setSelectedNode(node) {
			this.$emit("selected", node)
		},
		expand() {
			if (!this.node.hasChildren()) return
			this.expanded = !this.expanded
		}
	}
}
</script>

<style scoped>
.tree-item:hover {
	background: rgb(249, 250, 250);
	cursor: pointer;
}

.tree-item:hover .tree-item {
	background: initial;
}

.arrow {
	transition: all 120ms ease-in;
	width: 20px;
	height: 20px;
}

.arrow svg.ico {
	color: rgb(255, 255, 255);
	fill: white;
}

/*
.arrow:hover {
	cursor: pointer;
}
*/

.disable_selection {
	user-select: none;
}

.expander {
	border: 1px solid transparent;
}
.expander:hover {
	background-color: rgb(249, 249, 250);
	border: 1px solid;
	cursor: pointer;
	border-radius: 4px;
}

.arrow-rotated {
	transform: rotate(90deg);
}

.arrow-invisible {
	visibility: hidden;
}
.fadein {
	animation: fadein 280ms ease-in-out;
}
</style>
